import { createSelector } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { moduleName } from "./common";
import { workspacesReducers } from "./workspaces";
export const reducers = workspacesReducers;
export { moduleName } from "./common";
export { apiReducers, apiReducersPath, apiMiddleware } from "./api";
export const useWorkspacesSelector = useSelector;
export const workspaceDataSelector = createSelector((state) => state[moduleName], (x) => x);
